import ps_Kim   from './ps_Kim.jpg';
import ps_Park  from './ps_Park.jpg';
import ps_Jeong from './ps_Jeong.jpg';
import ps_Jeon  from './ps_Jeon.jpg';
import ps_Oh    from './ps_Oh.jpg';


export const pastorsImg = {
  ps_Kim,
  ps_Park,
  ps_Jeong,
  ps_Jeon,
  ps_Oh,
} as const;

export type PastorImgKey = keyof typeof pastorsImg;
